import React, { useState } from 'react';
import IconWithCount from '../icon/icon.counter.component';
import SharedModal from './shared.modal.component';
import { addArticleEvent } from 'store/action/article.action';
import history from 'config/history';
import { useDispatch } from 'react-redux';
import Icon from 'style/fonts/glyphmaps/icon.component';
export default function ArticleActions({
  article,
  like_count,
  dislike_count,
  comments,
}) {
  const [open, setOpen] = useState(false);

  const _sharedClick = () => setOpen(true);

  const _closeClick = () => setOpen(false);

  const _commentArticle = () =>
    history.push(`/artigos/${article.slug}#commentArticle`, {
      article: article,
    });

  const dispatch = useDispatch();

  return (
    <>
      <SharedModal slug={article.slug} open={open} close={_closeClick} />
      <IconWithCount
        fontFamily="AntDesign"
        name="like1"
        color="#AAA"
        size={23}
        className="article-icon"
        clickCount={like_count}
        onClick={() => dispatch(addArticleEvent(article.id, 'LIKE'))}
      />
      <IconWithCount
        fontFamily="AntDesign"
        name="dislike1"
        color="#AAA"
        size={23}
        clickCount={dislike_count}
        className="article-icon"
        onClick={() => dispatch(addArticleEvent(article.id, 'DISLIKE'))}
      />
      <IconWithCount
        fontFamily="MaterialCommunityIcons"
        name="message-text"
        size={23}
        color="#AAA"
        clickCount={comments ? comments.length : 0}
        className="article-icon"
        onClick={_commentArticle}
      />
      <Icon
        fontFamily="Entypo"
        name="share"
        color="#AAA"
        size={23}
        clickCount=""
        className="flex-row align-center justify-center article-icon"
        onClick={_sharedClick}
      />
    </>
  );
}
